import { render } from "./InventoryUpdateDrawer.vue?vue&type=template&id=c696a186"
import script from "./InventoryUpdateDrawer.vue?vue&type=script&lang=js"
export * from "./InventoryUpdateDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__